import { Drawer } from "antd";
import "../../components/design/CreateFolderModal.scss";
import { DownOutlined } from "@ant-design/icons";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import { DsaCreateFolderContent } from "./DsaCreateFolderContent";

export interface DsaCreateFolderDrawerProps {
  uploadIds: string[];
  isVisible: boolean;
  onClose: (uploadIds: string[], folderToMove?: DsaUploadFolderDto | null, folder?: DsaUploadFolderDto) => void;
  folderToMove: DsaUploadFolderDto | null;
  folderNameExists: (folder: DsaUploadFolderDto | null, name: string) => boolean | undefined;
  activeFolder: DsaUploadFolderDto | null;
}

export function DsaCreateFolderDrawer({
  uploadIds,
  isVisible,
  onClose,
  folderToMove,
  folderNameExists,
  activeFolder
}: DsaCreateFolderDrawerProps) {
  return (
    <Drawer
      className={"create-folder-modal mobile-bottom-menu"}
      visible={isVisible}
      onClose={() => onClose([])}
      closeIcon={<DownOutlined />}
      placement={"bottom"}
      title={"New Folder"}
      height={"263px"}
    >
      <DsaCreateFolderContent
        uploadIds={uploadIds}
        onClose={onClose}
        folderToMove={folderToMove}
        parentFolder={activeFolder}
        folderNameExists={folderNameExists}
      />
    </Drawer>
  );
}
